
const list: any =
{
  getslides: 'https://mapi.lapin365.com/api/catalog/slide',
  homepageproducts: 'https://mapi.lapin365.com/api/product/homepageproducts',
  productdetail: 'https://mapi.lapin365.com/api/product/detail',
  shoppingcart: 'https://mapi.lapin365.com/api/shoppingcart/get',
  addproducttocartfromdetail:
    'https://mapi.lapin365.com/api/shoppingcart/addproducttocartfromdetail',
  updateshoppingcart: 'https://mapi.lapin365.com/api/shoppingcart/updatecart',
  checkout: 'https://mapi.lapin365.com/api/checkout/checkout',
  customeraddresses: 'https://mapi.lapin365.com/api/customer/addresses',
  addressdelete: 'https://mapi.lapin365.com/api/customer/addressdelete',
  addressadd: 'https://mapi.lapin365.com/api/customer/addressadd',
  addressedit: 'https://mapi.lapin365.com/api/customer/addressedit',
  discountreceive: 'https://mapi.lapin365.com/api/discount/receive',
  customerorders: 'https://mapi.lapin365.com/api/order/customerorders',
  orderdetails: 'https://mapi.lapin365.com/api/order/details',
  orderplace: 'https://mapi.lapin365.com/api/order/place',
  orderpay: 'https://mapi.lapin365.com/api/order/pay',
  ordercancel: 'https://mapi.lapin365.com/api/order/cancel',
  productattributechange:
    'https://mapi.lapin365.com/api/product/attributechange',
  shoppingcartgetpice: 'https://mapi.lapin365.com/api/shoppingcart/getpice',
  productdetailsattributechange:
    'https://mapi.lapin365.com/api/product/productdetailsattributechange',
  province: 'https://mapi.lapin365.com/api/customer/province',
  city: 'https://mapi.lapin365.com/api/customer/city',
  area: 'https://mapi.lapin365.com/api/customer/area',
  street: 'https://mapi.lapin365.com/api/customer/street',
  orderconfirm: 'https://mapi.lapin365.com/api/order/confirm',
  orderdelayautoconfirm:
    'https://mapi.lapin365.com/api/order/delayautoconfirm',
  forgetpsw: 'https://my.ruanmei.com/?page=forgetpsw&app={platform}',
  userLoginInfo: 'http://my.ruanmei.com/api/User/Get',
  register: 'https://my.ruanmei.com/?page=register&app={platform}',
  gettpwd: 'https://api.lapin365.com/callback/gettpwd?url={url}',
  userLogin: 'http://my.ruanmei.com/api/User/Login',
  updateopenid: 'https://mapi.lapin365.com/api/customer/updateopenid',
  discountget: 'https://mapi.lapin365.com/api/discount/getdiscouts',
  exchange: 'https://mapi.lapin365.com/api/order/exchange',
  modifynick: 'https://my.ruanmei.com/api/User/ModifyNick',
  modifypassword: 'https://my.ruanmei.com/api/User/ModifyPassword',
  searchproducts: 'https://mapi.lapin365.com/api/catalog/searchproducts',
  orderprepay: 'https://mapi.lapin365.com/api/order/prepay',
  getordercount: 'https://mapi.lapin365.com/api/order/getordercount',
  favoriteadd: 'https://mapi.lapin365.com/api/customer/addfavorite',
  favoritedel: 'https://mapi.lapin365.com/api/customer/deletefavorite',
  getfavorites:
    'https://mapi.lapin365.com/api/customer/getfavoriteprodutlist',
  getuserbindinfo: 'https://my.ruanmei.com/api/Weixin/UserBindInfo',
  bindweixin: 'https://my.ruanmei.com/openplat/app/callback.aspx',
  uploadpicture: 'https://rise.lapin365.com/api/picture/upload',
  placereturnrequest:
    'https://mapi.lapin365.com/api/returnrequest/placereturnrequest',
  getreturnrequest:
    'https://mapi.lapin365.com/api/returnrequest/getreturnrequest',
  reorder: 'https://mapi.lapin365.com/api/order/reorder',
  ordercancelpaid: 'https://mapi.lapin365.com/api/order/cancelpaid',
  ordercancelrequestdetail:
    'https://mapi.lapin365.com/api/order/getcancelrequestdetail',
  getcancelrequestreasons:
    'https://mapi.lapin365.com/api/order/getcancelrequestreasons',
  getproductextrainfo:
    'https://mapi.lapin365.com/api/product/getproductextrainfo',
  getaftersales: 'https://mapi.lapin365.com/api/returnrequest/getaftersales',
  getrewardpointhistory:
    'https://mapi.lapin365.com/api/customer/getrewardpointhistory',
  gethomepagecontent:
    'https://mapi.lapin365.com/api/catalog/gethomepagecontent',
  getreturnrequestdetail:
    'https://mapi.lapin365.com/api/returnrequest/getreturnrequestdetail',
  getcoupon: 'https://mapi.lapin365.com/api/discount/getcoupon',
  favoritetabname: 'https://mapi.lapin365.com/api/customer/favoritetabname',
  apiver: '2.11',
}

const get = (apiKey: string, params?: any): string => {
  const apisList = list;
  let result = "";
  if (apiKey && apiKey.startsWith("http")) {
    result = apiKey;
  } else if (apiKey && apiKey.startsWith("//")) {
    result = `https:${apiKey}`;
  } else if (apisList[apiKey] && apisList[apiKey].startsWith("http")) {
    result = apisList[apiKey];
  } else if (apisList[apiKey] && apisList[apiKey].startsWith("//")) {
    result = `https:${apisList[apiKey]}`;
  }

  if (params) {
    Object.keys(params).forEach((key) => {
      const value = encodeURIComponent(params[key]);
      if (result.indexOf(`{${key.toLowerCase()}}`) !== -1) {
        result = result.replace(`{${key.toLowerCase()}}`, value)
      } else {
        const keyValue = `${key}=${value}`;
        result += (result.indexOf("?") !== -1 ? "&" : "?") + keyValue;
      }
    })
  }
  return result;
};


export const fetchJsonp = (options: { url: string, callback: string, timeout: number }) => {
  return new Promise<{ success: boolean, message: string, data?: any }>((resolve) => {
    const newScriptTag = document.createElement('script');
    const head = document.getElementsByTagName('head')[0];
    let loadFinished = false;
    const timer = setTimeout(() => {
      if (!loadFinished) {
        resolve({ success: false, message: "请求超时" })
      }
    }, options.timeout || 10000);
    (window as any)[`${options.callback}`] = function (res: any) {
      // eslint-disable-next-line prefer-rest-params
      resolve({ success: true, message: "请求成功", data: res })
      try {
        head.removeChild(newScriptTag)
        // eslint-disable-next-line no-empty
      } catch (error) {

      }
      loadFinished = true;
      clearTimeout(timer)
    }
    newScriptTag.type = 'text/javascript';
    newScriptTag.async = true;
    newScriptTag.charset = 'utf-8';
    newScriptTag.src = options.url;
    head.appendChild(newScriptTag);
  })
}

export default {
  // set,
  get,
}
